<template>
    <div class="container-bg">
      <markdown-section :label="$t('sectionProfile.summary')" :value="bio" field="bio"
        :placeholder="placeHolders.summary" :allowBlank="true"
        @startEdit="sumEditingCount(1)" @stopEdit="sumEditingCount(-1)">
      </markdown-section>
      <markdown-section v-if="mentorDescription !== ''" :label="$t('sectionProfile.help')" field="mentorDescription"
        :value="mentorDescription" :placeholder="placeHolders.mentorDescription" :allowBlank="true"
        @startEdit="sumEditingCount(1)" @stopEdit="sumEditingCount(-1)">
      </markdown-section>
      <tag-section :label="$t('sectionProfile.skills')" callbackName="skills"
        :tags="skills" :placeholder="placeHolders.skills"
        @startEdit="sumEditingCount(1)" @stopEdit="sumEditingCount(-1)">
      </tag-section>
      <tag-section :label="$t('sectionProfile.interests')" callbackName="interests"
        :tags="interests" :placeholder="placeHolders.interests"
        @startEdit="sumEditingCount(1)" @stopEdit="sumEditingCount(-1)">
      </tag-section>
      <social-handle-section :user="this.user"></social-handle-section>
      <badges v-if="badges.length > 0" :badges="badges" :user="user"></badges>
    </div>
</template>

<script>
import state from '../../state'

import MarkdownSection from './MarkdownSection'
import Badges from './Badges'
import TagSection from './TagSection'
import SocialHandleSection from './SocialHandleSection'

import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'

import i18n from '@/i18n'

export default {
  props: ['user', 'profile'],
  components: {
    MarkdownSection,
    Badges,
    TagSection,
    SocialHandleSection
  },
  mixins: [auth, componentState],
  computed: {
    bio: function () {
      return this.profile.bio || ''
    },
    mentorDescription: function () {
      return this.profile.mentorDescription || ''
    },
    badges: function () {
      return this.profile.userBadges || []
    },
    skills: function () {
      return this.profile.skills ? this.profile.skills.map((skill) => { return skill.name }) : []
    },
    interests: function () {
      return this.profile.interests ? this.profile.interests.map((interest) => { return interest.name }) : []
    },
    placeHolders: function () {
      if (this.viewingOwnProfile) {
        return {
          summary: i18n.t('sectionProfile.summaryDescription'),
          skills: i18n.t('sectionProfile.skillsDescription'),
          interests: i18n.t('sectionProfile.interestsDescription'),
          mentorDescription: 'Interested in helping others with your knowledge and experience?  Tell us how you can help to let other users know that they can reach out to you if they have an engineering-related question.'
        }
      }

      return {
        summary: this.user.userName + i18n.t('sectionProfile.noSummary'),
        skills: this.user.userName + i18n.t('sectionProfile.noSkills'),
        interests: this.user.userName + i18n.t('sectionProfile.noInterests')
      }
    },
    viewingOwnProfile: function () {
      return this.currentUser.uuid === this.user.uuid
    }
  },

  methods: {
    sumEditingCount: function (value) {
      const currentValue = this._get(state.editingCount)
      return this._set(state.editingCount, currentValue + value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

  .container-bg {
    background-color: #F2F2F2;
    padding-bottom: 4rem;
    position:relative;
    min-height: calc(100vh - 52px);
  }

  ::v-deep .social-containers {
    margin-bottom: 1rem;
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

</style>
